import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';  
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import TagManager from 'react-gtm-module';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { store } from 'store';
import AppContainer from '../App/components/AppContainer/index';
import RegistrationSuccess from '../AuthPopup/components/Register/RegistrationSuccess';  
import { theme } from 'utils/theme';
import { gtmID } from 'utils/config';
import { HelmetProvider } from 'react-helmet-async';
import CookieNotice from "components/CookieNotice"
import SessionBoundary from './components/SessionBoundary'
import { SearchViewportProvider } from 'components/InteractiveSearch/SearchViewportContext'


TagManager.initialize({ gtmId: gtmID });

const App = () => {
  return (
    <HelmetProvider>
    <Router>
      <meta name="referrer" content="no-referrer" />
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
              <QueryParamProvider adapter={ReactRouter6Adapter}>
                <SearchViewportProvider>
                <SessionBoundary>
                <CookieNotice />
                <Routes>
                  <Route path="/registration-success" element={<RegistrationSuccess />} />
                  <Route path="/*" element={<AppContainer />} />
                </Routes>
                </SessionBoundary>
                </SearchViewportProvider>
              </QueryParamProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </Provider>
    </Router>
    </HelmetProvider>
  );
}

export default App;
